"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Global
__exportStar(require("./app/initiatives/ANTD_INITIATIVES_STATUS_COLORS.js"), exports);
// -> Events
__exportStar(require("./global/events/MOUSE.js"), exports);
// -> Routes
__exportStar(require("./global/routes/index.js"), exports);
// -> Search
__exportStar(require("./global/search/SEARCH.js"), exports);
// -> Support
__exportStar(require("./global/support/EMAILS.js"), exports);
__exportStar(require("./global/support/URL.js"), exports);
// -> Sync
__exportStar(require("./app/sync/index.js"), exports);
// -> Timeouts
__exportStar(require("./global/timeouts/APP.js"), exports);
__exportStar(require("./global/FORMATS.js"), exports);
// -> UI
// --> AntD
__exportStar(require("./global/ui/antd/CLIENT_ID.js"), exports);
__exportStar(require("./global/ui/antd/DOMAIN.js"), exports);
__exportStar(require("./global/ui/antd/FILE_NAME.js"), exports);
__exportStar(require("./global/ui/antd/INITIATIVE_NAME.js"), exports);
__exportStar(require("./global/ui/antd/INVITE_EMAIL.js"), exports);
__exportStar(require("./global/ui/antd/INVITE_FIRST_NAME.js"), exports);
__exportStar(require("./global/ui/antd/INVITE_LAST_NAME.js"), exports);
__exportStar(require("./global/ui/antd/LINK_TITLE.js"), exports);
__exportStar(require("./global/ui/antd/LINK_URL.js"), exports);
__exportStar(require("./global/ui/antd/ORGANIZATIONS_MIGRATION.js"), exports);
__exportStar(require("./global/ui/antd/SUBDOMAIN.js"), exports);
__exportStar(require("./global/ui/antd/TASK_NAME.js"), exports);
// --> Messages
__exportStar(require("./global/ui/messages/COPY.js"), exports);
__exportStar(require("./global/ui/notifications/COPY.js"), exports);
__exportStar(require("./global/ui/placeholders/COPY.js"), exports);
__exportStar(require("./global/ui/form-items/index.js"), exports);
__exportStar(require("./copy/GENERIC.js"), exports);
__exportStar(require("./copy/ORGANIZATION_TYPE_LABELS.js"), exports);
__exportStar(require("./copy/SONAR_OBJECTS.js"), exports);
__exportStar(require("./copy/SPECIFIC.js"), exports);
__exportStar(require("./constants/EMOJIS.js"), exports);
__exportStar(require("./constants/AUTOCOMPLETE.js"), exports);
__exportStar(require("./constants/LINKS.js"), exports);
// Gateway
__exportStar(require("./gateway/index.js"), exports);
// App
__exportStar(require("./app/index.js"), exports);
// Dashboard
__exportStar(require("./dashboard/index.js"), exports);
// Admin Dashboard
__exportStar(require("./admin-dashboard/index.js"), exports);
//# sourceMappingURL=index.js.map